import {
    PLAYTECH_API_EVENTS as CORE_API_EVENTS
} from 'js/hooks/usePublicAPI/hooks/useEventsAPI/constants';

export const PLAYTECH_API_EVENTS = {
    ...CORE_API_EVENTS,
    /**
     * The event fires when the deposit has been successfully completed.
     * @memberOf Playtech.API.events
     * @event DEPOSIT_FIRST
     * @property {Array.<{ amount: Number, code: String, method: String, status: String }>} options
     * @example Playtech.on('DEPOSIT_FIRST', ([{ amount: 1, currency: 'CHF', code: '40564463', method: 'Retail Deposit', totalDepositCount: '35', status: 'waiting', userId: 'X0d2EJDS7GcjkPd9gEoyQ==' }]) => {
     *     // ...
     * });
     */
    DEPOSIT_FIRST: 'deposit:first',
    /**
     * The event fires when the deposit has been successfully completed.
     * @memberOf Playtech.API.events
     * @event DEPOSIT_TWO_PLUS
     * @property {Array.<{ amount: Number, code: String, method: String, status: String }>} options
     * @example Playtech.on('DEPOSIT_TWO_PLUS', ([{ amount: 1, currency: 'CHF', code: '40564463', method: 'Retail Deposit', totalDepositCount: '35', status: 'waiting', userId: 'X0d2EJDS7GcjkPd9gEoyQ==' }]) => {
     *      // ...
     * });
     */
    DEPOSIT_TWO_PLUS: 'deposit:twoPlus',
    /**
     * The event fires when the image has been unsuccessfully loaded.
     * @memberOf Playtech.API.events
     * @event IMAGE_LOAD_FAIL
     * @property {Array.<{ gameCode: String }>} options
     * @example Playtech.on('IMAGE_LOAD_FAIL', ({ gameCode: '40564463' }) => {
     *     // ...
     * });
     */
    IMAGE_LOAD_FAIL: 'image:fail'
};
